<div class="table-wrapper">
  <table mat-table cdkDropListGroup matSort [dataSource]="dataSource">
    @if (display$ | async; as display) {
      @for (
        column of columns$ | async;
        track column.definition.uid;
        let index = $index;
        let isLast = $last
      ) {
        <ng-container [matColumnDef]="column.definition.uid">
          <th
            *matHeaderCellDef
            mat-header-cell
            [mat-sort-header]="column.definition.uid"
          >
            <pr-report-builder-resolved-column-label
              [column]="column"
              [hideSubtitle]="true"
            />

            @if (!readOnly) {
              <button
                mat-icon-button
                class="small-button"
                [matMenuTriggerFor]="columnMenu"
                (click)="$event.stopPropagation()"
              >
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #columnMenu="matMenu">
                @if (index === 0) {
                  <button
                    mat-menu-item
                    (click)="columnManager.editGroup(column, display.chart)"
                  >
                    <mat-icon>edit</mat-icon> Edit
                  </button>
                } @else {
                  <button
                    mat-menu-item
                    (click)="columnManager.edit(column, display.chart)"
                  >
                    <mat-icon>edit</mat-icon> Edit
                  </button>
                }
                <button
                  mat-menu-item
                  [disabled]="index === 0"
                  (click)="columnManager.remove(column, display.chart)"
                >
                  <mat-icon>delete</mat-icon> Remove
                </button>
                <mat-divider />
                <button
                  mat-menu-item
                  [disabled]="index < 2"
                  (click)="columnManager.moveLeft(column, display.chart)"
                >
                  <mat-icon>arrow_back</mat-icon> Move Left
                </button>
                <button
                  mat-menu-item
                  [disabled]="index === 0 || isLast"
                  (click)="columnManager.moveRight(column, display.chart)"
                >
                  <mat-icon>arrow_forward</mat-icon> Move Right
                </button>
                <mat-divider />
                <button
                  mat-menu-item
                  [disabled]="index === 0"
                  (click)="columnManager.addLeft(column, display.chart)"
                >
                  <mat-icon>add</mat-icon> Add Column Left
                </button>
                <button
                  mat-menu-item
                  (click)="columnManager.addRight(column, display.chart)"
                >
                  <mat-icon>add</mat-icon> Add Column Right
                </button>
              </mat-menu>
            }
          </th>
          <td *matCellDef="let row" mat-cell>
            <ng-container
              *ngIf="{ row, column } | map: getDataPoint : this as dataPoint"
            >
              <ng-container *ngIf="dataPoint | map: isLink; else textValue">
                <a
                  *ngIf="dataPoint | map: hasValidLink"
                  target="_blank"
                  href="{{ dataPoint | metric }}"
                  >Open Link
                  <mat-icon class="icon-xxs">open_in_new</mat-icon></a
                >
              </ng-container>

              <ng-template #textValue>
                <span
                  *ngIf="dataPoint | map: isText; else metricValue"
                  class="text"
                  matTooltipShowDelay="500"
                  [matTooltip]="dataPoint | metric"
                >
                  {{ dataPoint | metric }}
                </span>
              </ng-template>

              <ng-template #metricValue>
                {{ dataPoint | metric }}
              </ng-template>
            </ng-container>
          </td>
        </ng-container>
      }
    }
    <tr *matHeaderRowDef="columnIds$ | async" mat-header-row></tr>
    <tr *matRowDef="let row; columns: columnIds$ | async" mat-row></tr>
  </table>
</div>
<mat-paginator showFirstLastButtons [pageSizeOptions]="pageSizeOptions" />
